import { MentionSource } from '../components/editor/plugins/mention-plugin';
import { NoteType } from '../contexts/personal-notes-context';

export function getMentionConfigByNoteType(noteType?: keyof typeof NoteType) {
  switch (noteType) {
    case NoteType.EventNote:
    case NoteType.GeneralNote:
      return MentionSource.All;
    case NoteType.VentureNote:
      return MentionSource.Mentor;
    case NoteType.FounderNote:
    case NoteType.MentorNote:
    default:
      return null;
  }
}
